export default {
  methods: {
    defaultPhone() {
      return ({
        number: '',
        extension: ''
      })
    }
  }
}